import { render, staticRenderFns } from "./simpleLayout.vue?vue&type=template&id=54ec0322&"
import script from "./simpleLayout.vue?vue&type=script&lang=js&"
export * from "./simpleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports